import React from 'react';
import { ToastContainer, toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import classes from './Toaster.module.css'; // This will be the CSS file for custom styles
import clsx from 'clsx';
import Button from '../Components/UI/Button';
// Custom cancel button component
const CancelButton = ({ closeToast }) => (
  <Button
    variants="cancel"
    className={clsx(classes['custom-cancel-btn'])}
    onClick={() => {
      toast.dismiss();
    }}
    label={'Cancel'}
  />
);

// Custom content for the toast
const CustomToast = ({ message = 'Sign up successfully' }) => (
  <div className={clsx(classes['custom-toast-content'])}>
    <p className={clsx(classes['custom-toast-message'])}>{message}</p>
    <CancelButton />
  </div>
);

const triggerToast = (message="", type) => {
  toast(<CustomToast message={message} />, {
    className: clsx(classes['custom-toast']),
    progressClassName: clsx('custom-progress-bar', {
      successProgressBar: type === 'success',
      warnProgressBar: type === 'warn',
      errorProgressBar: type === 'error'
    }),
    autoClose: 60000, // You can control auto-close behavior here
    closeOnClick: false,
    transition: Slide,
    hideProgressBar: false
  });
};

export { triggerToast };
